<template>
  <div class="app-container">
    <el-form ref="form" :model="{ form: form }" label-width="120px">
      <div class="box" v-for="(item, i) in form" :key="i">
        <div class="boxDel" @click="delBox(i)">
          <i class="el-icon-circle-close"></i>
        </div>
        <el-form-item label="请选择题目类型">
          <el-select
            v-model="item.type"
            placeholder="请选择题目类型"
            style="width: 200px"
            class="filter-item"
            :disabled="isEdit ? true : false"
          >
            <el-option label="单选题" :value="1" />
            <el-option label="多选题" :value="2" />
            <el-option label="填空题" :value="3" />
            <el-option label="简答题" :value="4" />
            <el-option label="判断题" :value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="题库分类">
          <el-select
            v-if="type == 1"
            v-model="item.student_question_bank_type_id"
            placeholder="请选择题库分类"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-select
            v-else
            v-model="item.teacher_question_bank_type_id"
            placeholder="请选择题库分类"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="题目标题">
          <el-input
            v-model="item.title"
            placeholder="请输入内容"
            type="textarea"
            :rows="4"
            style="margin-top: 10px"
          ></el-input>
        </el-form-item>
        <p
          v-if="item.type == 3"
          style="
            color: red;
            font-size: 14px;
            margin-top: -15px;
            padding-left: 120px;
          "
        >
          温馨提示:填空题需要填写的地方请使用 {input} 占位
        </p>
        <!-- 选择题盒子 -->
        <el-form-item label="选项" v-if="item.type == 1 || item.type == 2">
          <div
            class="box_cneter_select"
            v-for="(option, index) in item.option"
            :key="index"
          >
            <el-form-item
              :label="String.fromCharCode(option.name + index)"
              label-width="60px"
            >
              <el-input
                style="width: 250px; margin-left: 10px"
                v-model="option.content"
                :placeholder="`请输入${String.fromCharCode(
                  option.name + index
                )}`"
              ></el-input>
            </el-form-item>
            <el-checkbox
              v-model="option.isanswer"
              @change="checkbox(i, index)"
              style="margin-left: 10px"
            >
              是否答案
            </el-checkbox>
            <el-button
              type="danger"
              size="mini"
              style="margin-left: 10px"
              @click="optionDel(i, index)"
            >
              删除
            </el-button>
          </div>
          <div class="optionAdd" v-if="item.option.length < 6">
            <el-button type="primary" @click="optionAdd(i, item.type)">
              添加
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="判断答案" v-if="item.type == 5">
          <el-radio-group v-model="item.answer">
            <el-radio label="正确"></el-radio>
            <el-radio label="错误"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="答案" v-if="item.type == 3">
          <el-input
            v-model="item.answer"
            placeholder="请输入试题答案"
            type="textarea"
            :rows="4"
            style="margin-top: 10px"
          ></el-input>
        </el-form-item>

        <el-form-item label="试题解析">
          <el-input
            v-model="item.analysis"
            placeholder="请输入试题解析"
            type="textarea"
            :rows="4"
            style="margin-top: 10px"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="add" v-if="!isEdit">
      <el-button type="success" @click="add" style="margin-top: 10px">
        添加
      </el-button>
    </div>
    <div class="btn">
      <el-button @click="$router.go(-1)">返回</el-button>
      <el-button type="primary" @click="submit" :loading="btnLoading">
        提交
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      semester: "",
      options: [],
      professionals: [],
      value: "",
      input: "",
      score: 0,
      id: null,
      form: [
        {
          id: null,
          student_question_bank_type_id: null,
          teacher_question_bank_type_id: null,
          type: null,
          title: "",
          option: [], //选项，选择题才有选项,
          answer: "", //答案
          analysis: "", //解析
        },
      ],
      formDataRules: {
        score: [
          { required: true, message: "请填写试题分数", trigger: "change" },
        ],
        questions_title: [
          { required: true, message: "请填写试题标题", trigger: "change" },
        ],
        multiple: [
          {
            type: "array",
            required: true,
            message: "请填写试题分数",
            trigger: "change",
          },
        ],
        content: [
          { required: true, message: "请填写选项内容", trigger: "change" },
        ],
        questions_answer: [
          { required: true, message: "请填写试题答案", trigger: "change" },
        ],
      },
      btnLoading: false,
      type: null,
      isEdit: null,
      typeList: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.isEdit = this.$route.query.isEdit;
    if (this.id) this.getDetail();
    this.gettypeList();
  },
  mounted() {},
  methods: {
    delBox(index) {
      console.log();
      if (this.form.length == 1) {
        return;
      }
      this.form.splice(index, 1);
    },
    optionAdd(index) {
      console.log(index);
      let type = this.form[index].type;
      console.log(type);
      if (this.form[index].option.length > 5) {
        return;
      }
      this.form[index].option.push({ name: 65, content: "", isanswer: false });
    },
    optionDel(index, i) {
      console.log(index, i);
      this.form[index].option.splice(i, 1);
      this.$forceUpdate(); //强制更新
    },
    add() {
      this.form.push({
        id: null,
        student_question_bank_type_id: null,
        teacher_question_bank_type_id: null,
        type: null,
        title: "",
        option: [], //选项，选择题才有选项,
        answer: "", //答案
        analysis: "", //解析
      });
    },
    checkbox(boxi, index) {
      let type = this.form[boxi].type;
      if (type == 1) {
        // console.log(boxi, index);
        this.form[boxi].option.forEach((item) => {
          // console.log(item);
          item.isanswer = false;
        });
        this.form[boxi].option[index].isanswer = true;
      }
      // this.form.answer = data.name;
      this.$forceUpdate(); //强制更新
    },
    gettypeList() {
      let url = "";
      if (this.type == 1) {
        url = "/api/backend/studentQuestionBank/typeList"; //学生详情
      } else {
        url = "/api/backend/teacherQuestionBank/typeList"; //教师详情
      }
      request({
        url: url,
        method: "get",
        params: { limit: 99999999 },
      }).then((response) => {
        this.typeList = response.data.data;
      });
    },
    getDetail() {
      let url = "";
      if (this.type == 1) {
        url = "/api/backend/studentQuestionBank/detail"; //学生详情
      } else {
        url = "/api/backend/teacherQuestionBank/detail"; //教师详情
      }
      request({
        url: url,
        method: "get",
        params: {
          id: this.id,
        },
      }).then((response) => {
        this.form[0] = response.data;
        this.form[0].option = JSON.parse(response.data.option);
        this.$forceUpdate(); //强制更新
        // this.multiple = JSON.parse(response.data.option);
      });
    },
    submit() {
      console.log(this.form);
      this.form.forEach((item) => {
        if (item.type == 1 || item.type == 2) {
          item.whether = item.option.find((value) => value.isanswer == true);
        } else if (item.type == 3 || item.type == 5) {
          item.whether = item.answer;
        }
      });
      for (let index = 0; index < this.form.length; index++) {
        const item = this.form[index];
        if (item.type != 4) {
          if (!item.teacher_question_bank_type_id && this.type == 2) {
            this.$message.error("请选择题库分类");
            return;
          }
          if (!item.student_question_bank_type_id && this.type == 1) {
            this.$message.error("请选择题库分类");
            return;
          }
          if (!item.title) {
            this.$message.error("题目标题不能为空");
            return;
          }
          if (!item.whether) {
            this.$message.error("答案不能为空");
            return;
          }
        } else {
          if (!item.teacher_question_bank_type_id && this.type == 2) {
            this.$message.error("请选择题库分类");
            return;
          }
          if (!item.student_question_bank_type_id && this.type == 1) {
            this.$message.error("请选择题库分类");
            return;
          }
          if (!item.title) {
            this.$message.error("题目标题不能为空");
            return;
          }
        }
      }
      this.form.forEach((item) => {
        if (item.type == 1 || item.type == 2) {
          let answerZ = "";
          item.option.forEach((i, index) => {
            if (i.isanswer) {
              if (answerZ) {
                answerZ = answerZ + "," + (i.name + index);
              } else {
                answerZ = i.name + index;
              }
            }
          });
          item.answer = answerZ;
        }
      });
      this.btnLoading = true;
      if (this.isEdit) {
        this.oneupData();
      } else {
        this.upALLdata();
      }
    },
    //新增
    upALLdata() {
      this.btnLoading = true;
      let url = "";
      if (this.type == 1) {
        url = "/api/backend/studentQuestionBank/manyStore"; //学生
      } else {
        url = "/api/backend/teacherQuestionBank/manyStore"; //教师
      }
      request({
        url: url,
        method: "post",
        data: {
          question_banks: this.form,
        },
      })
        .then((response) => {
          this.btnLoading = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.$router.go(-1);
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
    //修改
    oneupData() {
      this.btnLoading = true;
      let url = "";
      if (this.type == 1) {
        url = "/api/backend/studentQuestionBank/store"; //学生
      } else {
        url = "/api/backend/teacherQuestionBank/store"; //教师
      }
      request({
        url: url,
        method: "post",
        data: this.form[0],
      })
        .then((response) => {
          this.btnLoading = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.$router.go(-1);
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-form-item {
//     display: flex;
//     align-items: center;
// }
.boxDel {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 10px;
  font-size: 30px;
  color: red;
}
.top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .top_titile {
    width: 110px;
    text-align: left;
    margin-right: 20px;
  }
}
.tips {
  display: flex;
  justify-content: space-between;
  width: 90%;
  text-align: center;
  margin-top: 40px;
}
.box {
  position: relative;
  width: 50%;
  border: 1px solid #dcdfe6;
  padding: 20px;
  margin-top: 20px;
  .box_top {
    display: flex;
    justify-content: space-between;
    .box_top_left {
      display: flex;
    }
    // .box_btn{
    //   height: 70px;
    // }
  }
  .box_cneter {
    margin-top: 20px;
  }
  .box_btn {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
.btn {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
.box_cneter_select {
  display: flex;
  align-items: center;
  // margin-top: 20px;
  margin-bottom: 20px;
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>